<template>
  <div class="w-full h-full WalletFlowDetail bg-[#151A1F] fixed top-0 z-50 pt-[52px]">
    <withTopNav
      leftText="Detalhes da Conta"
      fixed
      :onClickLeft="
        () => {
          $emit('close');
        }
      "
    >
      <div class="w-full px-[20px] text-[16px] text-[#fff]/45 p-[20px]">
        <div class="w-full rounded-[10px] flex flex-col gap-[1px]">
          <div
            class="w-full rounded-t-[10px] bg-[#2C7952]/40 p-[10px] flex justify-between"
          >
            <span>{{ $t('Registro.WalletFlowDetail.Type') }}</span>
            <span class="text-[#fff] text-[15px]">{{
              flowTypes[walletFlowItem?.type]?.text
            }}</span>
          </div>
          <div class="w-full bg-[#2C7952]/20 p-[10px] flex justify-between">
            <span>Valor</span>
            <span class="text-[#fff] text-[15px]"
              >{{ Number(walletFlowItem?.amount) > 0 ? "+" : "" }}
              {{ formatter().format(walletFlowItem?.amount) }}</span
            >
          </div>
          <div class="w-full bg-[#2C7952]/40 p-[10px] flex justify-between">
            <span>Saldo</span>
            <span class="text-[#fff] text-[15px]">{{
              formatter().format(walletFlowItem?.balanceAfter)
            }}</span>
          </div>
          <div class="w-full bg-[#2C7952]/20 p-[10px] flex justify-between items-center">
            <span>{{ $t('Registro.WalletFlowDetail.Number') }} <br />{{ $t('Registro.WalletFlowDetail.Transaction') }}</span>
            <div class="flex text-[#fff] text-[15px] items-center">
              <span class="w-[120px] overflow-hidden text-ellipsis">{{
                walletFlowItem?.id
              }}</span>
              <img
                :src="copy"
                class="w-[20px] h-[20px] ml-[10px]"
                @click="copyFlowId(walletFlowItem?.id)"
              />
            </div>
          </div>
          <div
            class="w-full rounded-b-[10px] bg-[#2C7952]/40 p-[10px] flex justify-between"
          >
            <span>Data</span>
            <span class="text-[#fff] text-[15px]">{{
              dayjs(walletFlowItem?.createTime).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </div>
        </div>
      </div>
    </withTopNav>
  </div>
</template>

<script setup lang="ts">
import { formatter } from "@/utils";
import copy from "./../images/copy.png";
import { copyText } from "@/utils";
import dayjs from "dayjs";
// import { flowTypes } from "./../constants";
import withTopNav from "@/layouts/withTopNav.vue";
import i18n from "@/i18n";
const t = i18n.global.t;
import { getLabel } from "./../constants";
const { flowTypes } = getLabel(t);
const { walletFlowItem } = defineProps({
  walletFlowItem: Object,
});

const emit = defineEmits(["close"]);

const copyFlowId = (flowId) => {
  copyText(flowId);
};
</script>

<style lang="scss" scoped></style>
